<template>
  <div>
    <el-input
      class="npwp-input"
      :disabled="disabled"
      :placeholder="placeholder"
      :size="size"
      type="text"
      v-model="displayValue"
      @blur="isInputActive = false"
      @focus="isInputActive = true" />
  </div>
</template>

<script>
import IMask from 'imask'
let masked = IMask.createMask({
  mask: '00.000.000.0-000.000'
})

export default {
  props: {
    value: {

    },
    size: {
      type: String,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: null,
    },
  },

  data: function () {
    return {
      isInputActive: false
    }
  },
  computed: {
    displayValue: {
      get: function () {
        if (this.value == null) return ''
        return masked.resolve(this.value)
      },
      set: function (modifiedValue) {
        masked.unmaskedValue = modifiedValue
        this.$emit('input', masked.unmaskedValue)
      }
    }
  },

}

</script>

<style lang="scss">
</style>
